/*
 * Ryan O'Dowd
 * 2025-10-02
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import Clipboard from '@react-native-clipboard/clipboard';
import {
  IconButton,
} from 'react-native-paper';
import Menu from '@components/common/Menu';
import {
  Share,
} from 'react-native';
import fb from '@utils/firebase';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';

const SMS_MAX_CHARS = 256; // @TODO: this isn't actually max because the link, title, etc. are in the message as well

const SelectionMenu = (props: SelectionMenuProps) => {
  // @TODO: const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  const [_isMenuOpen, setIsMenuOpen] = useState(false);

  const passsageTextSanitized = props.passageText.replace(/(\r\n|\n|\r)/gm, ' ').replace(/\s+/g, ' ');
  const passageTextPreview = (passsageTextSanitized.length <= SMS_MAX_CHARS
    ? passsageTextSanitized
    : `${passsageTextSanitized.slice(0, SMS_MAX_CHARS)}...`
  );

  return (
    <Menu
      anchor={
        <IconButton
          style={props.style}
          disabled={!props.passage}
          icon='share'
          iconColor={props.iconColor || styles.colors.white}// @TODO: make white default prop value instead of || here
          size={props.size}
          onPress={() => setIsMenuOpen(true)}
        />
      }
      visible={_isMenuOpen}
      onDismiss={() => setIsMenuOpen(false)}
    >
      <Menu.Item
        title='Copy to clipboard'// @TODO: i18n
        onPress={() => {
          setIsMenuOpen(false);
          fb.logEvent(fb.analytics, 'copy_passage', {location: props.locationForAnalytics});
          Clipboard.setString(`${props.passage.prettyPassageName(true)}, "${passsageTextSanitized}"`);
        }}
      />
      <Menu.Item
        title='Share passage'// @TODO: i18n
        onPress={async () => {
          setIsMenuOpen(false);
          // @TODO: update strings
          fb.logEvent(fb.analytics, 'share_passage', {location: props.locationForAnalytics});
          try {
            await Share.share({
              message: `${props.passage.prettyPassageName(true)}\n"${passageTextPreview}"`,
              url: `${globals.webUrl}?p=${props.passage.toApiNotation()}`,
              title: props.passage.prettyPassageName(true),
            }, {
              // Android only:
              dialogTitle: 'Share passage', // @TODO: i18n
            });
          } catch (error) {
            if (error.message === 'Share canceled') {
              return;
            }
            fb.recordError(fb.crashlytics, error);
          }
        }}
      />
    </Menu>
  );
};

class SelectionMenuProps {
  passage: any;
  passageText: string;
  locationForAnalytics: string;

  style?: any;
  iconColor?: string;
  size?: number;
};

export default SelectionMenu;
